import Vue from "vue";
import Router from "vue-router";
import TopNav from "../view/topNav/topNav.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/en",
      name: "en",
      component: TopNav,
    },
    {
      path: "/ar",
      name: "ar",
      component: TopNav,
    },
  ],
});
